export default __webpack_public_path__ + "static/apple-icon-144x144-ecf0bf231468d29ca67e5f7b1189c075.png";